import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getAuthorizationOptions = () => ({ headers: authenticationService.authHeader() });

export const confirmPaymentWithFoid = async (transactionId, bankName, pageId, transferData, isApprovalOptional) => {
  const result = await requestFunnel.post('floid/confirm-payment', {
    transactionId,
    bankName,
    pageId,
    transferData,
    isApprovalOptional
  }, getAuthorizationOptions());
  return result.data;
};

export const manuallySetTimeoutErrorWithFloid = async (transactionId, bankName, rutIn, moneyAmount) => {
  const rut = rutIn.substring(rutIn.length - 4);
  const result = await requestFunnel.post(`floid/callback/${transactionId}`, {
    bankName,
    rut,
    moneyAmount,
    isValid: false,
    error: {
      name: 'TimeoutError',
      origin: 'creditu'
    }
  });
  return result.data;
};
